export default __webpack_public_path__ + "static/media/vinyl_maroon.9f37cc23.svg";